import React, { useEffect, useState } from 'react';

import ConfirmField from './ConfirmField';

import { ADDITIONAL_DATA_TYPE } from 'utils/CustomEnums';

const OtherInfoTextField = ({
  language,
  question = {},
  isConfirm,
  editAction,
}) => {
  const { placeholder, defaultValue, questionFormat, fieldName } = question;
  const isNumeral = questionFormat === ADDITIONAL_DATA_TYPE.NUMBER;

  const [inputValue, setInputValue] = useState(defaultValue);

  useEffect(() => {
    setInputValue(defaultValue);
  }, [defaultValue]);

  const onEdit = (value) => {
    editAction(fieldName, value);
  };

  if (isConfirm) {
    return <ConfirmField value={defaultValue} />;
  }

  return (
    <div>
      <input
        className="account-input-with-downarrow field-text"
        {...(isNumeral
          ? {
              type: 'number',
              inputMode: 'numeric',
            }
          : {})}
        value={inputValue}
        placeholder={placeholder}
        onChange={(e) => {
          const text = e.target.value;
          onEdit(text);
        }}
      />
    </div>
  );
};

export default OtherInfoTextField;
